var map = {
	"./bg.json": [
		973,
		0
	],
	"./cs.json": [
		974,
		1
	],
	"./da.json": [
		975,
		2
	],
	"./de.json": [
		976,
		3
	],
	"./el.json": [
		977,
		4
	],
	"./en.json": [
		978,
		5
	],
	"./es-ES.json": [
		979,
		6
	],
	"./es-MX.json": [
		980,
		7
	],
	"./fi.json": [
		981,
		8
	],
	"./fr.json": [
		982,
		9
	],
	"./hu.json": [
		983,
		10
	],
	"./it.json": [
		984,
		11
	],
	"./ja.json": [
		985,
		12
	],
	"./ko.json": [
		986,
		13
	],
	"./nb.json": [
		987,
		14
	],
	"./nl.json": [
		988,
		15
	],
	"./pl.json": [
		989,
		16
	],
	"./pt-BR.json": [
		990,
		17
	],
	"./pt-PT.json": [
		991,
		18
	],
	"./ro.json": [
		992,
		19
	],
	"./ru.json": [
		993,
		20
	],
	"./sl.json": [
		994,
		21
	],
	"./sv.json": [
		995,
		22
	],
	"./ta.json": [
		996,
		23
	],
	"./th.json": [
		997,
		24
	],
	"./tr.json": [
		998,
		25
	],
	"./zh-CN.json": [
		999,
		26
	],
	"./zh-TW.json": [
		1000,
		27
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 965;
module.exports = webpackAsyncContext;